// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__vSBSw","fullScreen":"Loader_fullScreen__xixEr","loaderChildren":"Loader_loaderChildren__TtyP0","loaderIcon":"Loader_loaderIcon__DdPMW"};